// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2J7Pz","content":"LoadingAlert_content__cnJeC"};